// The import of @shopify/monorail is only allowed in this file.
// Breaking this rule will break the dynamic import of monorail.
// eslint-disable-next-line no-restricted-imports
import type {Monorail as MonorailType} from '@shopify/monorail';

let MonorailPromise: Promise<MonorailType>;

export const getMonorailProducer: () => Promise<MonorailType> = () => {
  // @TODO: Check if Monorail is already loaded in the window by trekkie.
  // Pseduocode:
  // if(window.analytics?.trekkie.Monorail){
  //   return new Promise(resolve=>resolve(window.analytics.trekkie.Monorail));
  // }

  if (MonorailPromise) {
    return MonorailPromise;
  }

  MonorailPromise = new Promise((resolve, reject) => {
    import('@shopify/monorail')
      .then((MonorailImport) => {
        const Monorail = MonorailImport.Monorail;
        const producer =
          // eslint-disable-next-line no-process-env
          process.env.NODE_ENV === 'production'
            ? Monorail.createHttpProducer({production: true})
            : Monorail.createLogProducer({debugMode: true});
        resolve(producer);
      })
      .catch((error) => reject(error));
  });

  return MonorailPromise;
};

export const monorailProducer = getMonorailProducer;
